<!--App.svelte-->
<script>
  import { onMount, onDestroy } from 'svelte';
  import { writable } from 'svelte/store';
  import './reducera.css';
  import Menu from './Menu.svelte';
  import Header from './Header.svelte';
  import Footer from './Footer.svelte';
  // import CouponInfo from './CouponInfo.svelte';
  import MatchTable from './MatchTable.svelte';
  // import GroupButtonsContent from './GroupButtonsContent.svelte';
  import GroupButtonsPanel from './GroupButtonsPanel.svelte';
  // import SettingsPane from './SettingsPane.svelte';
  import FunctionButtons from './FunctionButtons.svelte';
  // import { alwaysVisible } from './GroupButtonsPanelStore.svelte';
  // import BrowserDetector from './BrowserDetector.svelte';
  import LoadingScreen from './LoadingScreen.svelte';
  import PWAUpdateHandler from './PWAUpdateHandler.svelte';

  import { draw } from 'svelte/transition';

  let isLoading = true;
  let error = null;

  let hideMenuItems = true;
  let showMenu = true;
  let showResponse = true;
  let NaN = '-';

  let spel;
  let omg;
  let activeGame;
  let gameData;
  let menuGames;
  let matches = writable([]);
  let matchesOld = writable([]);
  let drawNumber;
  let closeDate;
  let jackpot = 0;
  let revenue = 25000000;
  let insats = [1];
  let count;
  let groups = [
    { row: 0, id: 1, name: '1 X 2', active: 0, disabled: true, max: 13 },
    { row: 1, id: 2, name: 'Gul', desc: 'gula', active: 0, disabled: true, max: 0, minMax: [0,0] },
    { row: 2, id: 3, name: 'Röd', desc: 'röda', active: 0, disabled: true, max: 0, minMax: [0,0] },
    { row: 3, id: 4, name: 'Grön', desc: 'gröna', active: 0, disabled: true, max: 0, minMax: [0,0] },
    { row: 4, id: 5, name: 'Rosa', desc: 'rosa', active: 0, disabled: true, max: 0, minMax: [0,0] },
    { row: 5, id: 6, name: '1', active: 0, disabled: true, max: 0, minMax: [0,0] },
    { row: 6, id: 7, name: 'X', active: 0, disabled: true, max: 0, minMax: [0,0] },
    { row: 7, id: 8, name: '2', active: 0, disabled: true, max: 0, minMax: [0,0] }
  ];
  let reduceActive;

  let slicedGroupsColors = groups.slice(1, 5);
  // let slicedGroupsColors2 = groups.slice(3, 5);
  let slicedGroups1X2 = groups.slice(5, 8);
  let activeGroup = 0;
  let activeTab = 1;
  let buttonsCouponInfo = [
    { name: 'Streck', img: 'streck.svg', active: true },
    { name: 'Odds', img: 'odds.svg', active: true },
    { name: 'Odds%', img: 'odds-procent.svg', active: false },
    { name: 'Oddsförändring', img: 'forandring.svg', active: false },
    { name: 'Värde', img: 'varde.svg', active: false },
  ];
  let infoCount = 2;

  let infoMessages = [
    'Fyll i din grundrad innan du börjar reducera systemet',
    'Fortsätt bygg din grundrad, eller skapa & justera regler för reducering med knapparna ovan',
    'Fyll i din grundrad med minst en halvgardering innan du börjar färgreducera systemet med ',
    'Bestäm regel för hur många ',
    ' tecken får vara med i samma rad',
    'Fyll i minst två matcher med halvgardering och ',
    ' tecken för möjlighet till effektiv reducering',
    ' tecken',
    'Fyll i din grundrad med minst en halvgardering innan du börjar teckenreducera systemet',
    'Bestäm regler för hur många 1X2-tecken det får vara i samma rad',
    'Fyll i minst två matcher med halvgardering för möjlighet till effektiv teckenreducering',
    ];

    let values1X2 = [
    {},
    {},
    {},
    {},
    {},
    { minMax: [0,0] },
    { minMax: [0,0] },
    { minMax: [0,0] }
  ];

  let currentMin;
  // let revenueValues = [0,0];

  let intervalId;
  const fetchInterval = 120000; // Fetch every 2 min
  let elapsedTime = '';
  let elapsedTimeIntervalId;
  let apiCallTimestamp;

  let v1 = [];
  let vX = [];
  let v2 = [];
  let antT = [];
  let utd = [0, 0, 100000000];

  let antalTecken = [0,0,0,0];
  let footerLabels = ['Spikar', 'Halvgarderingar', 'Helgarderingar', 'Oreducerat'];

  let isFormDisabled = true;
  let isDeleteDisabled = true;

  let payload = {
      v1: [],
      vX: [],
      v2: [],
      antT: [0, 0, 13, 0, 13, 0, 13],
      utd: [0, 0, 100000000],
      yellow: [0, 0, 13],
      green: [0, 0, 13],
      red: [0, 0, 13],
      pink: [0, 0, 13],
      drawNumber: [1],
      insats: [1]
    };

  let response;
  let submittedLive = false;
  let responseLive;

  let undoStack = [];
  let redoStack = [];
  
  const selectedButtonGroup = writable('');

  let container; // This will reference the HTML element you want to convert

  let activeIndex = -1;
  let longPressTimer;
  let pressStartTime;
  let startX, startY;
  const LONG_PRESS_DURATION = 1000; // 1 second
  const MOVE_THRESHOLD = 10; // pixels
  let isTouchDevice = false;
  let lastTouchTime = 0;
  const TOUCH_TIMEOUT = 2000; // milliseconds

  const PRIORITY_GAMES = ['stryktipset', 'europatipset', 'topptipset'];

  async function fetchData(spel,omg) { 
    isLoading = true;
    error = null;
    if (omg === undefined) omg = 1;
    let activeGameData;
    try {
      const response = await fetch(`https://api-reducera.gamblingcabin.se/omgInfo?spel=${spel}&omg=${omg}`);
      if (response.ok) {
        activeGameData = await response.json();
//        console.log(activeGameData.omgInfo.productName[0]);

        if (activeGameData.omgInfo.productName[0] === 0 && activeGameData.allOpenDraws && activeGameData.allOpenDraws.length > 0) {
            const sortedDraws = activeGameData.allOpenDraws.sort((a, b) => 
                new Date(a.closeTime) - new Date(b.closeTime)
            );

            const nextGame = sortedDraws.find(draw => draw.productName === "Stryktipset") ||
                           sortedDraws.find(draw => draw.productName === "Europatipset") ||
                           sortedDraws.find(draw => draw.productName === "Topptipset");

            if (nextGame) {
                console.log("Found next game:", nextGame);
                activeGame = nextGame.productName.toLowerCase();
                drawNumber = nextGame.drawNumber;
                closeDate = nextGame.closeTime.slice(0, 10);
                console.log("Spel:", activeGame);
                return await fetchData(
                    nextGame.productName.toLowerCase(), 
                    nextGame.drawNumber
                );
            }
        }

        gameData = activeGameData.omgInfo;
        menuGames = activeGameData.allOpenDraws;
        // if (gameData.productName[0] === 0) {
        //   let openDraws;
        //   let fetchSpel;
        //   let fetchOmg;
        //   openDraws = activeGameData.allOpenDraws;
        //   fetchSpel = openDraws.productName[0];
        //   fetchOmg = Number(openDraws.drawNumber[0]);
        //   fetchData(fetchSpel,fetchOmg);
        //   return;
        // } else {
          matches.set(gameData.SvF);
          matchesOld.set(gameData.SvF);
          count = gameData.SvF.length;
          if (gameData.productName[0]) {
            activeGame = gameData.productName[0].toLowerCase();
            drawNumber = gameData.drawNumber[0];
            closeDate = gameData.closeTime[0].slice(0, 10);
            insats = [1];
            revenue = 25000000;
            utd = [0, 0, 100000000];
            if (gameData.jp[0]) jackpot = parseJackpot(gameData.jp[0]);
            if (!gameData.jp[0]) jackpot = 0;
            if (activeGame.includes('topptipset')) activeGame = 'topptipset';
            if (activeGame === 'topptipset' || activeGame === 'powerplay') revenue = 1000000;
            if (activeGame === 'europatipset') revenue = 10000000;
          } else {
            error = "undefined";
          }
          changeThemeColor(activeGame);
          apiCallTimestamp = new Date();
          updateElapsedTime();
        // }
      } else {
        throw new Error('Failed to fetch data: ' + response.statusText);
      }
    } catch (err) {
      console.error('Error fetching data:', err);
      error = err.message;
    } finally {
      isLoading = false;
    }
  }

  async function updateData(game,round) {
    let activeGameData;
    matchesOld.set(gameData.SvF);
    if (round === undefined) round = 1;
    if (game !== activeGame || round !== drawNumber) {
      if (game.includes('topptipset')) game = 'topptipset';
      // spel = game;
      // omg = round;
      response = '';
      fetchData(game,round);
    } else {
      if (game === undefined) {
        game = 'stryktipset';
        round = 1;
        // if (game.includes('topptipset')) game = 'topptipset';
      }
      const response = await fetch(`https://api-reducera.gamblingcabin.se/omgInfo?spel=${game}&omg=${round}`);
        if (response.ok) {
          activeGameData = await response.json();
          gameData = activeGameData.omgInfo;
          matches.set(gameData.SvF);
          apiCallTimestamp = new Date();
          formatDateTime(gameData.closeTime[0]);
          updateElapsedTime();
        } else {
          console.error('Failed to fetch data:', response.statusText);
        }
    }
  }

  function updateElapsedTime() {
    const now = new Date();
    const diffInSeconds = Math.floor((now - apiCallTimestamp) / 1000);

    if (diffInSeconds < 60) {
      elapsedTime = `Data uppdaterat för ${diffInSeconds} sekund${diffInSeconds !== 1 ? 'er' : ''} sedan`;
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      elapsedTime = `Data uppdaterat för ${minutes} minut${minutes !== 1 ? 'er' : ''} sedan`;
    } else {
      elapsedTime = `Data uppdaterat ${apiCallTimestamp.toLocaleString()}`;
    }
  }

  // Start the periodic fetching
  function startFetching() {
    updateData(activeGame,drawNumber); // Initial fetch
    intervalId = setInterval(() => updateData(activeGame,drawNumber), fetchInterval);
  }

  // Stop the periodic fetching
  function stopFetching() {
    clearInterval(intervalId);
  }

  // Monitor the visibility of the window/app
  function handleVisibilityChange() {
    if (document.hidden) {
      stopFetching();
    } else {
      startFetching();
    }
  }

  onMount(() => {
  const urlParams = new URLSearchParams(window.location.search);
    // LÖS NÄR spel = mumbo jumbo
    spel = urlParams.get('spel') || 'stryktipset';
    omg = urlParams.get('omg') || '1';
    showMenu = urlParams.get('showMenu') || true;
    elapsedTimeIntervalId = setInterval(updateElapsedTime, 1000);
    fetchData(spel,omg);

    // Set up the periodic fetching and visibility change listener
    startFetching();
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      stopFetching();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      clearTimeout(longPressTimer);
    };
  });

  onDestroy(() => {
    clearInterval(elapsedTimeIntervalId);
  });

  async function handleSubmit(spel) {

    event.preventDefault();

    let v1X2 = '';

    payload.v1=v1;
    payload.vX=vX;
    payload.v2=v2;
    payload.antT[0]=groups[0].active;
    payload.antT[1]=groups[5].minMax[0];
    payload.antT[2]=groups[5].minMax[1];
    payload.antT[3]=groups[6].minMax[0];
    payload.antT[4]=groups[6].minMax[1];
    payload.antT[5]=groups[7].minMax[0];
    payload.antT[6]=groups[7].minMax[1];
    payload.utd[0]=utd[0];
    payload.utd[1]=utd[1];
    payload.utd[2]=utd[2];
    payload.yellow[0]=groups[1].active;
    payload.yellow[1]=groups[1].minMax[0];
    payload.yellow[2]=groups[1].minMax[1];
    payload.red[0]=groups[2].active;
    payload.red[1]=groups[2].minMax[0];
    payload.red[2]=groups[2].minMax[1];
    payload.green[0]=groups[3].active;
    payload.green[1]=groups[3].minMax[0];
    payload.green[2]=groups[3].minMax[1];
    payload.pink[0]=groups[4].active;
    payload.pink[1]=groups[4].minMax[0];
    payload.pink[2]=groups[4].minMax[1];
    payload.drawNumber=gameData.drawNumber[0];

    for (let i = 0; i < v1.length; i++) {
      v1X2 += `v1=${v1[i]}&`;
    }

    for (let i = 0; i < vX.length; i++) {
      v1X2 += `vX=${vX[i]}&`;
    }

    for (let i = 0; i < v2.length; i++) {
      v1X2 += `v2=${v2[i]}&`;
    }

const post = await fetch(`https://api-reducera.gamblingcabin.se/radInfo?spel=${spel}&${v1X2}antT=${groups[0].active}&antT=${groups[5].minMax[0]}&antT=${groups[5].minMax[1]}&antT=${groups[6].minMax[0]}&antT=${groups[6].minMax[1]}&antT=${groups[7].minMax[0]}&antT=${groups[7].minMax[1]}&utd=${utd[0]}&utd=${utd[1]}&utd=${utd[2]}&yellow=${groups[1].active}&yellow=${groups[1].minMax[0]}&yellow=${groups[1].minMax[1]}&red=${groups[2].active}&red=${groups[2].minMax[0]}&red=${groups[2].minMax[1]}&green=${groups[3].active}&green=${groups[3].minMax[0]}&green=${groups[3].minMax[1]}&pink=${groups[4].active}&pink=${groups[4].minMax[0]}&pink=${groups[4].minMax[1]}&drawNumber=${payload.drawNumber}&insats=${insats}&turnover=${revenue}&jp=${jackpot}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
    });

// const post = await fetch(`https://api-reducera.gamblingcabin.se/radInfo?spel=${spel}&&v1=1&v1=1&v1=1&v1=1&v1=1&v1=1&v1=1&v1=1&v1=1&v1=1&v1=1&v1=1&v1=1&vX=1&vX=1&vX=1&vX=1&vX=1&vX=1&vX=1&vX=1&vX=1&vX=1&vX=1&vX=1&vX=1&v2=0&v2=0&v2=0&v2=0&v2=0&v2=0&v2=0&v2=0&v2=0&v2=0&v2=0&v2=0&v2=0&antT=0&antT=0&antT=13&antT=0&antT=13&antT=0&antT=13&utd=0&utd=0&utd=100000000&yellow=0&yellow=0&yellow=13&red=0&red=0&red=13&green=0&green=0&green=13&pink=0&pink=0&pink=13`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//     });

    // const post = await fetch(`https://api-reducera.gamblingcabin.se/radInfo?spel=${spel}&drawNumber=${drawNumber}&prodName=${activeGame}`, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify(payload)
    // });

    if (!post.ok) {
      const message = `An error has occured: ${post.status}`;
      throw new Error(message);
    }

    const responseData = await post.json();
    response = responseData;
    console.log(responseData); // Log response or handle it as needed
  }


   async function handleSubmitLive(name,gamer,couponCost) {

    let v1X2 = '';

    payload.v1=v1;
    payload.vX=vX;
    payload.v2=v2;
    payload.antT[0]=groups[0].active;
    payload.antT[1]=groups[5].minMax[0];
    payload.antT[2]=groups[5].minMax[1];
    payload.antT[3]=groups[6].minMax[0];
    payload.antT[4]=groups[6].minMax[1];
    payload.antT[5]=groups[7].minMax[0];
    payload.antT[6]=groups[7].minMax[1];
    payload.utd[0]=utd[0];
    payload.utd[1]=utd[1];
    payload.utd[2]=utd[2];
    payload.yellow[0]=groups[1].active;
    payload.yellow[1]=groups[1].minMax[0];
    payload.yellow[2]=groups[1].minMax[1];
    payload.red[0]=groups[2].active;
    payload.red[1]=groups[2].minMax[0];
    payload.red[2]=groups[2].minMax[1];
    payload.green[0]=groups[3].active;
    payload.green[1]=groups[3].minMax[0];
    payload.green[2]=groups[3].minMax[1];
    payload.pink[0]=groups[4].active;
    payload.pink[1]=groups[4].minMax[0];
    payload.pink[2]=groups[4].minMax[1];
    payload.drawNumber=gameData.drawNumber[0];

    for (let i = 0; i < v1.length; i++) {
      v1X2 += `v1=${v1[i]}&`;
    }

    for (let i = 0; i < vX.length; i++) {
      v1X2 += `vX=${vX[i]}&`;
    }

    for (let i = 0; i < v2.length; i++) {
      v1X2 += `v2=${v2[i]}&`;
    }

   try {

      responseLive = `https://api-reducera.gamblingcabin.se/liverattning?name=${name}&tgc_snubbe=${gamer}&date=${closeDate}&n_rows=${couponCost}&spel=${activeGame}&${v1X2}antT=${groups[0].active}&antT=${groups[5].minMax[0]}&antT=${groups[5].minMax[1]}&antT=${groups[6].minMax[0]}&antT=${groups[6].minMax[1]}&antT=${groups[7].minMax[0]}&antT=${groups[7].minMax[1]}&utd=${utd[0]}&utd=${utd[1]}&utd=${utd[2]}&yellow=${groups[1].active}&yellow=${groups[1].minMax[0]}&yellow=${groups[1].minMax[1]}&red=${groups[2].active}&red=${groups[2].minMax[0]}&red=${groups[2].minMax[1]}&green=${groups[3].active}&green=${groups[3].minMax[0]}&green=${groups[3].minMax[1]}&pink=${groups[4].active}&pink=${groups[4].minMax[0]}&pink=${groups[4].minMax[1]}&drawNumber=${payload.drawNumber}`;

     const response = await fetch(responseLive, {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json',
       }
     });
     
     if (response.ok) {
      submittedLive = true;
      console.log(response);
     } else {
       throw new Error('API submission failed');
     }
   } catch (error) {
     console.error('Error submitting values:', error);
     alert('Failed to submit values. Please try again.');
   }
 }


  function selectButton(group) {
    selectedButtonGroup.set(group);
    activeGroup = group;
  }

  function toggleCouponInfo(index) {
    if (buttonsCouponInfo[index].active) {
      // Allow deactivation if more than 1 is active
      if (buttonsCouponInfo.filter(button => button.active).length > 1) {
        buttonsCouponInfo[index].active = false;
      }
    } else {
      // Only allow activation if fewer than 3 are active
      if (buttonsCouponInfo.filter(button => button.active).length < 5) {
        buttonsCouponInfo[index].active = true;
      }
    }
    infoCount = buttonsCouponInfo.filter(button => button.active).length;
  }

  function handleTouchStart(rowIndex, column, event) {
    isTouchDevice = true;
    lastTouchTime = Date.now();
    activeIndex = rowIndex * 3 + column;
    pressStartTime = Date.now();
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
    longPressTimer = setTimeout(() => {
      if (activeIndex === rowIndex * 3 + column) {
        if (column === 2 && 
          ((vX[rowIndex] === 1 || v2[rowIndex] === 1) || 
            vX[rowIndex] + v2[rowIndex] === 0)) 
          v1[rowIndex] = 0;
        if (column === 3 && 
          ((v1[rowIndex] === 1 || v2[rowIndex] === 1) || 
            v1[rowIndex] + v2[rowIndex] === 0)) 
          vX[rowIndex] = 0;
        if (column === 4 && 
          ((vX[rowIndex] === 1 || v1[rowIndex] === 1) || 
            vX[rowIndex] + v1[rowIndex] === 0)) 
          v2[rowIndex] = 0;
      }
    }, LONG_PRESS_DURATION);
  }

  function handleTouchMove(event) {
    if (activeIndex !== -1) {
      const diffX = event.touches[0].clientX - startX;
      const diffY = event.touches[0].clientY - startY;
      if (Math.abs(diffX) > MOVE_THRESHOLD || Math.abs(diffY) > MOVE_THRESHOLD) {
        clearTimeout(longPressTimer);
        activeIndex = -1;
      }
    }
  }

  function handleTouchEnd(rowIndex, column) {
    if (activeIndex !== -1) {
      clearTimeout(longPressTimer);
      const pressDuration = Date.now() - pressStartTime;
      if (pressDuration < LONG_PRESS_DURATION) {
        activeIndex = -1;
        toggleCell(rowIndex, column);
      }
    }
  }

  function handleMouseDown(rowIndex, column, event) {
    if (isTouchDevice && Date.now() - lastTouchTime < TOUCH_TIMEOUT) {
    // Ignore mouse events that immediately follow touch events
      return;
    }
    activeIndex = rowIndex * 3 + column;
    pressStartTime = Date.now();
    startX = event.clientX;
    startY = event.clientY;
    longPressTimer = setTimeout(() => {
      if (activeIndex === rowIndex * 3 + column) {
        if (column === 2 && 
          ((vX[rowIndex] === 1 || v2[rowIndex] === 1) || 
            vX[rowIndex] + v2[rowIndex] === 0)) 
          v1[rowIndex] = 0;
        if (column === 3 && 
          ((v1[rowIndex] === 1 || v2[rowIndex] === 1) || 
            v1[rowIndex] + v2[rowIndex] === 0)) 
          vX[rowIndex] = 0;
        if (column === 4 && 
          ((vX[rowIndex] === 1 || v1[rowIndex] === 1) || 
            vX[rowIndex] + v1[rowIndex] === 0)) 
          v2[rowIndex] = 0;
      }
    }, LONG_PRESS_DURATION);
  }

  function handleMouseMove(event) {
    if (isTouchDevice && Date.now() - lastTouchTime < TOUCH_TIMEOUT) {
    // Ignore mouse events that immediately follow touch events
      return;
    }
    if (activeIndex !== -1) {
      const diffX = event.clientX - startX;
      const diffY = event.clientY - startY;
      if (Math.abs(diffX) > MOVE_THRESHOLD || Math.abs(diffY) > MOVE_THRESHOLD) {
        clearTimeout(longPressTimer);
        activeIndex = -1;
      }
    }
  }

  function handleMouseUp(rowIndex, column) {
    if (isTouchDevice && Date.now() - lastTouchTime < TOUCH_TIMEOUT) {
    // Ignore mouse events that immediately follow touch events
      return;
    }
    if (activeIndex !== -1) {
      clearTimeout(longPressTimer);
      const pressDuration = Date.now() - pressStartTime;
      if (pressDuration < LONG_PRESS_DURATION) {
        toggleCell(rowIndex, column);
      }
      activeIndex = -1;
    }
  }

  function handleMouseLeave() {
    if (isTouchDevice && Date.now() - lastTouchTime < TOUCH_TIMEOUT) {
    // Ignore mouse events that immediately follow touch events
      return;
    }
    clearTimeout(longPressTimer);
    activeIndex = -1;
  }

    function toggleCell(rowIndex, column) {

        // Save current state to undo stack
        undoStack = [...undoStack, {
            v1: [...v1],
            vX: [...vX],
            v2: [...v2],
            utd: [...utd]
        }];
        redoStack = []; // Clear redo stack

    if (column === 2) {
      if (activeGroup === 1 || activeGroup === 0) {
        if (v1[rowIndex] !== 1) {
          v1[rowIndex] = 1;
          if (groups[5].minMax[1] === groups[5].max && 
              groups[5].minMax[1] >= groups[5].minMax[0]) {
            groups[5].minMax[1]++;
          }
        } else if (vX[rowIndex] !== v2[rowIndex] || (vX[rowIndex] < 2 && v2[rowIndex] < 2)) {
          v1[rowIndex] = 0;
        }     
      } else if (activeGroup !== 1 && activeGroup !== 0) {
        if (v1[rowIndex] !== 0 && v1[rowIndex] !== activeGroup
            && ((vX[rowIndex] !== 0 && (v2[rowIndex] !== activeGroup && v2[rowIndex] !== 0))
            ||  (v2[rowIndex] !== 0 && (vX[rowIndex] !== activeGroup && vX[rowIndex] !== 0))
            ||  (vX[rowIndex] === 0 && (v2[rowIndex] !== activeGroup && v2[rowIndex] !== 0))
            ||  (v2[rowIndex] === 0 && (vX[rowIndex] !== activeGroup && vX[rowIndex] !== 0)))) {
              v1[rowIndex] = activeGroup;
                if (groups[activeGroup-1].minMax[1] === groups[activeGroup-1].max && 
                    groups[activeGroup-1].minMax[1] >= groups[activeGroup-1].minMax[0]) {
                      groups[activeGroup-1].minMax[1]++;
                }
        } else if (v1[rowIndex] === 0
            && ((vX[rowIndex] === 0 && (v2[rowIndex] !== activeGroup && v2[rowIndex] !== 0))
            ||  (v2[rowIndex] === 0 && (vX[rowIndex] !== activeGroup && vX[rowIndex] !== 0))
            ||  (vX[rowIndex] !== 0 && v2[rowIndex] !== activeGroup)
            ||  (v2[rowIndex] !== 0 && vX[rowIndex] !== activeGroup))) {
              v1[rowIndex] = activeGroup;
              groups[5].minMax[1]++; 
                if (groups[activeGroup-1].minMax[1] === groups[activeGroup-1].max && 
                    groups[activeGroup-1].minMax[1] >= groups[activeGroup-1].minMax[0]) {
                      groups[activeGroup-1].minMax[1]++;
                }
        } else if (v1[rowIndex] === activeGroup) {
          v1[rowIndex] = 1;
        }
      }

    } else if (column === 3) {
      if (activeGroup === 1 || activeGroup === 0) {
        if (vX[rowIndex] !== 1 ) {
          vX[rowIndex] = 1;
          if (groups[6].minMax[1] === groups[6].max && 
              groups[6].minMax[1] >= groups[6].minMax[0]) {
            groups[6].minMax[1]++;
          }
        } else if (v1[rowIndex] !== v2[rowIndex] || (v1[rowIndex] < 2 && v2[rowIndex] < 2)) {
          vX[rowIndex] = 0;
        }     
      } else if (activeGroup !== 1 && activeGroup !== 0) {
        if (vX[rowIndex] !== 0 && vX[rowIndex] !== activeGroup
            && ((v2[rowIndex] !== 0 && (v1[rowIndex] !== activeGroup && v1[rowIndex] !== 0))
            ||  (v1[rowIndex] !== 0 && (v2[rowIndex] !== activeGroup && v2[rowIndex] !== 0))
            ||  (v2[rowIndex] === 0 && (v1[rowIndex] !== activeGroup && v1[rowIndex] !== 0))
            ||  (v1[rowIndex] === 0 && (v2[rowIndex] !== activeGroup && v2[rowIndex] !== 0)))) {
          vX[rowIndex] = activeGroup;
          if (groups[activeGroup-1].minMax[1] === groups[activeGroup-1].max && 
              groups[activeGroup-1].minMax[1] >= groups[activeGroup-1].minMax[0]) {
            groups[activeGroup-1].minMax[1]++;
          }
        } else if (vX[rowIndex] === 0
            && ((v1[rowIndex] === 0 && (v2[rowIndex] !== activeGroup && v2[rowIndex] !== 0))
            ||  (v2[rowIndex] === 0 && (v1[rowIndex] !== activeGroup && v1[rowIndex] !== 0))
            ||  (v1[rowIndex] !== 0 && v2[rowIndex] !== activeGroup)
            ||  (v2[rowIndex] !== 0 && v1[rowIndex] !== activeGroup))) {
              vX[rowIndex] = activeGroup;
              groups[6].minMax[1]++;
                if (groups[activeGroup-1].minMax[1] === groups[activeGroup-1].max && 
                    groups[activeGroup-1].minMax[1] >= groups[activeGroup-1].minMax[0]) {
                      groups[activeGroup-1].minMax[1]++;
                }
        } else if (vX[rowIndex] === activeGroup) {
          vX[rowIndex] = 1;
        }
      }

    } else if (column === 4) {
      if (activeGroup === 1 || activeGroup === 0) {
        if (v2[rowIndex] !== 1) {
          v2[rowIndex] = 1;
          if (groups[7].minMax[1] === groups[7].max && 
              groups[7].minMax[1] >= groups[7].minMax[0]) {
            groups[7].minMax[1]++;
          }
        } else if (vX[rowIndex] !== v1[rowIndex] || (v1[rowIndex] < 2 && vX[rowIndex] < 2)) {
          v2[rowIndex] = 0;
        }     
      } else if (activeGroup !== 1 && activeGroup !== 0) {
        if (v2[rowIndex] !== 0 && v2[rowIndex] !== activeGroup
            && ((vX[rowIndex] !== 0 && (v1[rowIndex] !== activeGroup && v1[rowIndex] !== 0))
            ||  (v1[rowIndex] !== 0 && (vX[rowIndex] !== activeGroup && vX[rowIndex] !== 0))
            ||  (vX[rowIndex] === 0 && (v1[rowIndex] !== activeGroup && v1[rowIndex] !== 0))
            ||  (v1[rowIndex] === 0 && (vX[rowIndex] !== activeGroup && vX[rowIndex] !== 0)))) {
          v2[rowIndex] = activeGroup;
          if (groups[activeGroup-1].minMax[1] === groups[activeGroup-1].max && 
              groups[activeGroup-1].minMax[1] >= groups[activeGroup-1].minMax[0]) {
            groups[activeGroup-1].minMax[1]++;
          }
        } else if (v2[rowIndex] === 0
            && ((vX[rowIndex] === 0 && (v1[rowIndex] !== activeGroup && v1[rowIndex] !== 0))
            ||  (v1[rowIndex] === 0 && (vX[rowIndex] !== activeGroup && vX[rowIndex] !== 0))
            ||  (vX[rowIndex] !== 0 && v1[rowIndex] !== activeGroup)
            ||  (v1[rowIndex] !== 0 && vX[rowIndex] !== activeGroup))) {
              v2[rowIndex] = activeGroup;
              groups[7].minMax[1]++;
                if (groups[activeGroup-1].minMax[1] === groups[activeGroup-1].max && 
                    groups[activeGroup-1].minMax[1] >= groups[activeGroup-1].minMax[0]) {
                      groups[activeGroup-1].minMax[1]++;
                }
        } else if (v2[rowIndex] === activeGroup) {
          v2[rowIndex] = 1;
        }
      }
    }
  }

  function toggleColumn(column) {

        // Save current state to undo stack
        undoStack = [...undoStack, {
            v1: [...v1],
            vX: [...vX],
            v2: [...v2],
            utd: [...utd]
        }];
        redoStack = []; // Clear redo stack

      if (column === 2) {
        if (activeGroup === 1 || activeGroup === 0) {
          const allSelected = v1.every(v1 => v1 === 1);
          const allZero = v1.every(v1 => v1 === 0);
          if (allSelected) {
            v1 = v1.map(() => 0);
          } else if (allZero || !allSelected) {
            v1 = v1.map(() => 1);
          }
          groups[5].minMax[1] = count;
        }
    } else if (column === 3) {
        if (activeGroup === 1 || activeGroup === 0) {
          const allSelected = vX.every(vX => vX === 1);
          const allZero = vX.every(vX => vX === 0);
          if (allSelected) {
            vX = vX.map(() => 0);
          } else if (allZero || !allSelected) {
            vX = vX.map(() => 1);   
          }
          groups[6].minMax[1] = count;
        }
    } else if (column === 4) {
        if (activeGroup === 1 || activeGroup === 0) {
          const allSelected = v2.every(v2 => v2 === 1);
          const allZero = v2.every(v2 => v2 === 0);
          if (allSelected) {
            v2 = v2.map(() => 0);
          } else if (allZero || !allSelected) {
            v2 = v2.map(() => 1);
          }
          groups[7].minMax[1] = count;
        }
    }
  }

  function toggleShowMenu(status) {
    if (status === false) showMenu = false;
    if (status === true) showMenu = true;
    if (status === '') showMenu = !showMenu;
  }

 function formatDateTime(dateTimeString) {
    const date = new Date(dateTimeString);
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);

    let dayString;
    if (date.toDateString() === now.toDateString()) {
      dayString = "idag";
    } else if (date.toDateString() === tomorrow.toDateString()) {
      dayString = "imorgon";
    } else {
      // dayString = date.toLocaleDateString('sv-SE', { month: 'long', day: 'numeric' });
      dayString = date.toLocaleDateString('sv-SE', { weekday: 'long' });
    }

    const timeString = date.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit', hour12: false });

    return `${dayString} ${timeString}`;
  }

  function formatCurrencySEK(amount,suffixEnabled,showDivisor) {
    let suffix, divisor;
    let maxFractionDigits = 2;
    let noDivisor = false;

    if (Number.isInteger(amount)) {

        if (showDivisor === false) noDivisor = true;
  
        if (amount >= 1000000 && noDivisor === false) {
          suffix = ' mkr';
          divisor = 1000000;
        } else if (amount >= 1000 && noDivisor === false) {
          suffix = ' tkr';
          divisor = 1000;
          maxFractionDigits = 0;
        } else {
          suffix = ' kr';
          divisor = 1;
        }

      if (suffixEnabled === false) suffix = '';

      const formatter = new Intl.NumberFormat('sv-SE', {
        // style: 'currency',
        // currency: 'SEK',
        // notation: 'compact',
        // compactDisplay: 'short',
        minimumFractionDigits: 0,
        maximumFractionDigits: maxFractionDigits,
      });
      return formatter.format(amount / divisor).concat('', suffix);
    } else {
      return amount;
    }
  }

  function parseJackpot(jp) {
    // Convert to lowercase for easier matching
    if (typeof jp === "string") {
      jp = jp.toLowerCase();
      // extraMoney = parseInt(extraMoney);
    
      // Extract the numeric part
      const number = jp.match(/\d+(?:,\d+)?/)[0];
      // const number = jp.match(/\d+,\d+/)[0];
      const value = parseFloat(number.replace(",", ".")); // Converts to 3.5

      // const number = jp.match(/\d+(?:,\d+)?/)[0];
      // if (!number) return null;
      
      // const value = parseFloat(number[0].replace(",", "."));
      
      // Check for different multipliers
      if (jp.includes('milj')) {
          return value * 1000000;
      } else if (jp.includes('tusen')) {
          return value * 1000;
      } else if (jp.includes('k')) {
          return value * 1000;
      }
    } else {
      const value = parseInt(jp);
      return value;
    }
  }

  function formatCouponValueColor(value) {
    if (value <= 0.85) return 'couponValue1';
    if (value > 0.85 && value <= 0.95) return 'couponValue2';
    if (value > 0.95 && value <= 1.05) return 'couponValue3';
    if (value > 1.05 && value <= 1.15) return 'couponValue4';
    if (value > 1.15) return 'couponValue5';
  }

  // Function to change the number of elements
  function updateNumber(newSize) {
    // Save current state to undo stack
    // undoStack = [...undoStack, {
    //     v1: [...v1],
    //     vX: [...vX],
    //     v2: [...v2],
    //     utd: [...utd]
    // }];
    undoStack = []; // clear undo stack
    redoStack = []; // Clear redo stack

    count = newSize + 1; // Hack to force reactive array count
    count = newSize;
    response = '';
    groups[5].minMax = [0,0];
    groups[6].minMax = [0,0];
    groups[7].minMax = [0,0];
    utd = [0,0,100000000];
  }

function inputFieldMin(index, type) {
  const val = Math.min(Math.max(groups[index].minMax[0], 0), groups[index].minMax[1]);
  if (type === 'input') {
    groups[index].minMax[0] = val;
  } else if (type === 'decrease') {
    if ( val >= 1 && val <= groups[index].minMax[1] ) {
      groups[index].minMax[0] = val - 1;
    }
  } else if (type === 'increase') {
    if ( val >= 0 && val <= groups[index].minMax[1] - 1 ) {
      groups[index].minMax[0] = val + 1;
    }      
  }
}

function inputFieldMax(index, type) {
  const val = Math.min(Math.max(groups[index].minMax[1], 0), groups[index].max);
  if (type === 'input') {
    groups[index].minMax[1] = val;
  } else if (type === 'decrease') {
    if ( val > 1 && val <= groups[index].max ) {
      groups[index].minMax[1] = val - 1;
    }
  } else if (type === 'increase') {
    if ( val >= 0 && val <= groups[index].max - 1 ) {
      groups[index].minMax[1] = val + 1;
    }      
  }
}

function setGroupMinMax(value) {
  groups[value].minMax[0] = values1X2[value].minMax[0];
  groups[value].minMax[1] = values1X2[value].minMax[1];
}

function revenueHandleClick(interval) {
  let [lower, upper] = interval.split('-');
  utd[1] = revenueParseValue(lower);
  utd[2] = revenueParseValue(upper);
  // utd[2] = upper ? Math.min(reveuneParseValue(upper), 100000000) : 100000000;
}

function revenueValidateInput(event, isLower) {
  let value = Math.max(0, Math.min(parseFloat(event.target.value) || 0, 100000000));
  
  if (isLower) {
    utd[1] = Math.min(value, utd[2]);
    event.target.value = utd[1];
  } else {
    utd[2] = Math.max(value, utd[1]);
    event.target.value = utd[2];
  }
}

function revenueParseValue(value) {
  if (value.endsWith('K')) {
    return parseFloat(value) * 1000;
  } else if (value.endsWith('M')) {
    return parseFloat(value) * 1000000;
  } else if (value === '10M+') {
    return 10000000;
  } else {
    return parseFloat(value);
  }
}

// function updateRevenueValues() {
//     utd[1] = revenueValues[0];
//     utd[2] = revenueValues[1];
//     if (utd[1] > 0 || utd[2] < 100000000) utd[0] = 1;
// }

function handleKeydown(event) {
  // Check for Ctrl+Z (Windows/Linux) or Cmd+Z (Mac)
  if ((event.ctrlKey || event.metaKey) && event.key === 'z' && !event.shiftKey) {
    event.preventDefault(); // Prevent the default save action
    undo();
  }
  
  // Check for Ctrl+Shift+Z (Windows/Linux) or Cmd+Shift+Z (Mac)
  if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
    event.preventDefault(); // Prevent the default undo action
    redo();
  }
  
  // Check for Ctrl+U (Windows/Linux) or Cmd+U (Mac)
  if ((event.ctrlKey || event.metaKey) && event.key === 'u' && !event.shiftKey) {
    event.preventDefault(); // Prevent the default save action
    updateData(activeGame,drawNumber);
  }

  // Check for Ctrl+U (Windows/Linux) or Cmd+U (Mac)
  if ( event.key === 'Delete' || (event.key === 'Backspace' && event.metaKey) ) {
    event.preventDefault(); // Prevent the default save action
    updateNumber(count);
  }

}

function undo() {
    if (undoStack.length > 0) {
        redoStack = [...redoStack, {
            v1: [...v1],
            vX: [...vX],
            v2: [...v2],
            utd: [...utd]
        }];

        const lastState = undoStack.pop();
        v1 = lastState.v1;
        vX = lastState.vX;
        v2 = lastState.v2;
        utd = lastState.utd;

        // Force update (may not be necessary depending on your Svelte version)
        undoStack = [...undoStack];
        redoStack = [...redoStack];
    }
}

function redo() {
    if (redoStack.length > 0) {
        undoStack = [...undoStack, {
            v1: [...v1],
            vX: [...vX],
            v2: [...v2],
            utd: [...utd]
        }];

        const nextState = redoStack.pop();
        v1 = nextState.v1;
        vX = nextState.vX;
        v2 = nextState.v2;
        utd = nextState.utd;

        // Force update
        undoStack = [...undoStack];
        redoStack = [...redoStack];
    }
}

// Reactive statement to update counts whenever arrays change
  $: {
    const matrix = v1.map((_, index) => [v1[index], vX[index], v2[index]]);
    // Reset counts
    antalTecken = [0,0,0,0];
    for (let i = 0; i < groups.length; ++i) groups[i].max = 0;
    for (let i = 0; i < groups.length; ++i) groups[i].active = 0;
    for (let i = 0; i < groups.length; ++i) groups[i].disabled = true;
    isFormDisabled = true;
    matrix.forEach(row => {
      const rowcount = row.filter(value => value > 0).length;
      if (rowcount === 1) antalTecken[0]++;
      if (rowcount === 2) antalTecken[1]++;
      if (rowcount === 3) antalTecken[2]++;
      for (let i = 1; i < groups.length; i++) {
        const rowcount = row.filter(value => value === groups[i].id).length;
        if (rowcount > 0) {
          groups[i].max++;
          groups[i].active = 1;
          groups[i].disabled = false;
        }
      }
    });

    if (antalTecken[0] + antalTecken[1] + antalTecken[2] === 0 && utd[1] === 0 && utd[2] === 100000000 && groups[0].active === 0) isDeleteDisabled = true;
    else isDeleteDisabled = false;

    v1.forEach(row => {
      if (row !== 0) {
        groups[5].max++;
        groups[5].disabled = false;
      }
    });
    
    vX.forEach(row => {
      if (row !== 0) {
        groups[6].max++;
        groups[6].disabled = false;
      }
    });

    v2.forEach(row => {
      if (row !== 0) {
        groups[7].max++;
        groups[7].disabled = false;
      }
    });

    // Make sure minMax[0] and minMax[1] is not greater than max for each group
    for (let i = 1; i < groups.length; ++i) {
      if (groups[i].minMax[1] < groups[i].minMax[0]) groups[i].minMax[0] = groups[i].minMax[1];
      if (groups[i].max < groups[i].minMax[0]) groups[i].minMax[0] = groups[i].max;
      if (groups[i].max < groups[i].minMax[1]) groups[i].minMax[1] = groups[i].max;
    }

    if ( antalTecken[0] + antalTecken[1] + antalTecken[2] === count ) {
      antalTecken[3] = Math.pow(2, antalTecken[1]) * Math.pow(3, antalTecken[2]);
      isFormDisabled = false;
      // if ( antalTecken[1] + antalTecken[2] > 0 && groups[1].max + groups[2].max + groups[3].max + groups[4].max > 1 ) {
      //  isFormDisabled = false;
      // }
    } else {
      antalTecken[3] = 0;
      isFormDisabled = true;
    }

  }
  
// Reactive statement to adjust array length
  $: {

    v1 = Array.from({ length: count }, (_, index) => 0);
    vX = Array.from({ length: count }, (_, index) => 0);
    v2 = Array.from({ length: count }, (_, index) => 0);
  }

  $: {
      if (groups[5].minMax[0] > 0 || groups[5].minMax[1] < groups[5].max) groups[0].active = 1;
      if (groups[6].minMax[0] > 0 || groups[6].minMax[1] < groups[6].max) groups[0].active = 1;
      if (groups[7].minMax[0] > 0 || groups[7].minMax[1] < groups[7].max) groups[0].active = 1;
  }

  $: {
    for (let i = 5; i < groups.length; ++i) {
      values1X2[i].minMax[0] = groups[i].minMax[0];
      values1X2[i].minMax[1] = groups[i].minMax[1];
    }
      if (values1X2[5].minMax[0] > 0 || values1X2[5].minMax[1] < groups[5].max) groups[0].active = 1;
      if (values1X2[6].minMax[0] > 0 || values1X2[6].minMax[1] < groups[6].max) groups[0].active = 1;
      if (values1X2[7].minMax[0] > 0 || values1X2[7].minMax[1] < groups[7].max) groups[0].active = 1;
  }

  $: {
    if (utd[1] > 0 || utd[2] < 100000000) utd[0] = 1;
    else utd[0] = 0;
  }

  $: {
    reduceActive = false;
    for (let i = 0; i < groups.length; ++i) {
      if (groups[i].active === 1) reduceActive = true;
    } 
  }

  $: {
    if (activeGame === 'stryktipset') revenue = 25000000;
    if (activeGame === 'europatipset') revenue = 10000000; 
    if (activeGame === 'topptipset') revenue = 1000000;
    if (activeGame === 'powerplay') revenue = 1000000; 
  }

const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight()

let themeColor; // Initial theme color

function changeThemeColor(type) {
  if (type === 'stryktipset') themeColor = ['#07275C', 'white', 'invert(100%)', 'rgba(7,39,92,0.8)', 'brightness(0) saturate(100%) invert(10%) sepia(48%) saturate(3736%) hue-rotate(210deg) brightness(99%) contrast(99%)'];
  if (type === 'europatipset') themeColor = ['#008733', 'white', 'invert(100%)', 'rgba(0,135,51,0.8)', 'brightness(0) saturate(100%) invert(27%) sepia(70%) saturate(7385%) hue-rotate(148deg) brightness(97%) contrast(103%)'];
  if (type && type.includes('topptipset')) themeColor = ['#F29400', 'white', 'invert(100%)', 'rgba(242,148,0,0.8)', 'brightness(0) saturate(100%) invert(54%) sepia(95%) saturate(1071%) hue-rotate(3deg) brightness(97%) contrast(102%)'];
  if (type === 'powerplay') themeColor = ['#A00813', 'white', 'invert(100%)', 'rgba(160,8,19,0.8)', 'brightness(0) saturate(100%) invert(13%) sepia(87%) saturate(3659%) hue-rotate(346deg) brightness(80%) contrast(107%)'];

      // https://codepen.io/sosuke/pen/Pjoqqp
     // Change theme color to blue
    // You can set themeColor dynamically based on some condition
    // or user interaction
    document.querySelector('meta[name="theme-color"]').setAttribute('content', themeColor[0]);
    document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]').setAttribute('content', themeColor[0]);
    document.documentElement.style.setProperty('--themeColor1', themeColor[0]);
    document.documentElement.style.setProperty('--themeColor2', themeColor[3]);
    document.documentElement.style.setProperty('--themeColorText', themeColor[1]);
    document.documentElement.style.setProperty('--themeColorFill', themeColor[2]);
    document.documentElement.style.setProperty('--themeColorFill2', themeColor[4]);
}

</script>

<style>
  :root {
     --app-height: 100%;
  }

  /* Base styles for full height layout and no margin */
  :global(body, html) {
    font-family: "Lexend", sans-serif;
    padding: 0;
    margin: 0;
/*    background-color: red; */
  background: var(--themeColor1, #07275C);
/*   background: linear-gradient(180deg, var(--themeColor1, #008733) 0%,var(--themeColor2, #008733) 42%,white 100%); */
 
    overflow: hidden;
    width: 100vw;
    height: 100dvh;
    height: var(--app-height);
    min-height: -webkit-fill-available;
    padding-bottom: env(safe-area-inset-bottom);  
  }

</style>

<svelte:head>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&display=swap" rel="stylesheet">
</svelte:head>

<svelte:window on:keydown={handleKeydown}/>

<div class="container">
  <LoadingScreen {isLoading} {error} {updateData} {spel} {activeGame} />

  <Menu {showMenu} {hideMenuItems} {updateData} {menuGames} {formatDateTime} {formatCurrencySEK} {drawNumber} />

  <Header {gameData} {activeGame} {formatDateTime} {formatCurrencySEK} {buttonsCouponInfo} {toggleCouponInfo} />
<!-- <span style="color:white">{revenue} - {jackpot} - {insats} - {drawNumber} - {closeDate}</span> -->
  <!-- <CouponInfo {buttonsCouponInfo} {toggleCouponInfo} /> -->

  <div class="content">  
    <!-- <div class="left-column"> -->

      <MatchTable {activeGroup} {activeGame} {matches} {matchesOld} {toggleCell} {toggleColumn} {buttonsCouponInfo} {formatCouponValueColor} {infoCount} {v1} {vX} {v2} {formatDateTime} {elapsedTime} {handleTouchStart} {handleTouchMove} {handleTouchEnd} {handleMouseDown} {handleMouseMove} {handleMouseUp} {handleMouseLeave} />

      <GroupButtonsPanel bind:utd={utd} bind:jackpot={jackpot} bind:revenue={revenue} bind:insats={insats} {activeGroup} {activeGame} {groups} {selectButton} {slicedGroupsColors} {slicedGroups1X2} {antalTecken} {count} {inputFieldMin} {inputFieldMax} {infoMessages} {revenueHandleClick} {revenueValidateInput} {revenueParseValue} {formatCurrencySEK} {values1X2} {setGroupMinMax} {currentMin} />

    <!-- </div> -->

<!--     <div class="right-column">


      <SettingsPane {groups} {slicedGroups1X2} {inputFieldMin} {inputFieldMax} />


    </div> -->

  </div>

  <FunctionButtons bind:submittedLive={submittedLive} bind:insats={insats} {responseLive} {undo} {undoStack} {redo} {redoStack} {showResponse} {updateNumber} {count} {payload} {response} {handleSubmit} {handleSubmitLive} {activeGame} {reduceActive} {selectButton} {isFormDisabled} {isDeleteDisabled} {updateData} {utd} {formatCurrencySEK} {toggleShowMenu} {gameData} {matches} {groups} {v1} {vX} {v2} {antalTecken} /> 

  <Footer {antalTecken} {formatCurrencySEK} {footerLabels} />

  <PWAUpdateHandler 
    checkInterval={60 * 1000}
    buttonText="Uppdatera appen!"
    notificationText="Ny förbättrad version tillgänlig!"
    customClass="my-custom-class"
  />

</div>